import AsyncStorage from "@react-native-async-storage/async-storage";
import { SecureStorage } from "@helpers/storage";
import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet } from "react-native";
import IconButton from "../../../../components/ButtonIcon";
import PageTitle from "../../../../components/PageTitle";
import { AuthContext } from "../../../../contexts/auth";
import { GlobalContext } from "../../../../contexts/global";
import { formatCPF, formatDocument, formatPhone } from "../../../../helpers/util";
import { DeleteUser, GetUserById } from "../../../../services/Api/user";
import * as Colors from "../../../../styles/colors";
import Option from "../../components/Option";

export default function AccountInfo({ navigation }) {
  const [userData, setUserData] = useState({});
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  useEffect(() => setLoading({
    show: true,
    message: "Carregando seus dados",
  }), [])
  
  const { setIsSignUp } = useContext(AuthContext);

  useEffect(() => {
    (async () => {
      GetUserById()
        .then((value) => {
          setUserData(value);
          setLoading({ show: false, message: "" });
        })
        .catch((error) => {
          setShowAlert({
            type: "alert",
            title: "Atenção",
            message: "Ocorreu um erro ao retornar os seus dados.",
            show: true,
            confirmText: "Tentar Novamente",
            pressConfirm: () => {
              navigation.goBack();
            },
          });
        })
        .finally(() => setLoading({ show: false, message: "" }));
    })();
  }, []);

  const deleteUser = () => {
    setShowAlert({
      type: "warning",
      title: "Atenção",
      message: "Deseja realmente remover a conta? Essa ação é irreversivel.",
      show: true,
      confirmText: "Sim",
      pressConfirm: () => {
        deleteUserApi(userData.id);
      },
      cancelText: "Não",
      pressCancel: () => setShowAlert({ ...showAlert, show: false }),
    });
  };

  const deleteUserApi = (idUser) => {
    DeleteUser(idUser)
      .then((value) => {
        AsyncStorage.removeItem("biometria");
        SecureStorage.deleteItemAsync("email");
        SecureStorage.deleteItemAsync("password");
        setShowAlert({
          type: "success",
          title: "Atenção",
          message: "Usuário deletado com sucesso.",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
            setIsSignUp(false);
          },
        });
      })
      .catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Atenção",
          message: "Ocorreu um erro ao deletar o usuario.",
          show: true,
          confirmText: "Tentar Novamente",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      });
  };

  return (
    <PageTitle title={"Dados da conta"} navigation={navigation}>
      <ScrollView style={styles.viewSecundaria}>
        <Option
          subtitle={userData.name}
          icon={"account-outline"}
          title={"Nome"}
        />
        <Option
          icon={"email-outline"}
          subtitle={userData.email}
          title={"E-mail"}
        />
        <Option
          icon={"text-account"}
          subtitle={userData.document ? formatDocument(userData.document) : null}
          title={"Documento"}
        />
        <Option
          icon={"phone-outline"}
          subtitle={userData.phone ? formatPhone(userData.phone) : null}
          title={"Telefone"}
        />
      </ScrollView>
      <IconButton
        textoBotao={"Excluir conta"}
        onPress={() => deleteUser()}
        iconName={"delete"}
        estilo={{ backgroundColor: Colors.ALERT, width: "100%" }}
      />
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewSecundaria: {
    // backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    // padding: 8,
  },
});
